import "./CheckboxFilterInput.scss"
import { Checkbox, FormControlLabel } from "@mui/material"

interface ICheckboxFilterInputProps{
    label: string
    value: boolean | null,
    valueChanged: (value: string | boolean) => void
}

const CheckboxFilterInput = (props: ICheckboxFilterInputProps) => {

    const handleValueChange = () => {
        if(props.value === true){
            props.valueChanged(false)
        } else if (props.value === false) {
            props.valueChanged('')
        } else if (props.value  === null) {
            props.valueChanged(true)
        }
    }

    return (
        <div className="checkbox-filter-input-wrapper">
            <FormControlLabel
                value={props.label}
                sx={{
                    width: "100%",
                    margin: 0
                }}
                control={
                    <Checkbox 
                        checked={props.value === true}
                        indeterminate={props.value === false}
                        onChange={handleValueChange}
                        sx={{
                            padding: 0
                        }}
                    />
                }
                label={props.label}
                labelPlacement="bottom"
            />
        </div>
    )
}

export default CheckboxFilterInput